import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlow1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 1329,
	height: 871,
	viewBox: "-0 -200 1329 980",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		filter: "url(#filter0_f_20474_24871)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M1106.63 59.8588C1184.23 228.228 1049.21 455.933 805.066 568.452C560.919 680.971 300.095 635.696 222.499 467.328C144.904 298.959 279.92 71.2538 524.067 -41.2656C768.214 -153.785 1029.04 -108.51 1106.63 59.8588Z",
			fill: "#18A0FB",
			fillOpacity: .19
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("filter", {
		id: "filter0_f_20474_24871",
		x: .583984,
		y: -303.115,
		filterUnits: "userSpaceOnUse",
		children: /* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 100 })
	}) })]
});
export default SvgGlow1;
